import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useSuccessionTheme } from './SuccessionThemeProvider';
import { pctSymbol } from '../../utils/formatters';

const BcpTileFallback = () => {
  // Use succession theme context
  const { theme, isLightTheme, isDarkTheme, company } = useSuccessionTheme();
  
  // For fallback we always show 0% complete
  const completionPercentage = 0;
  
  return (
    <div className="bg-succession-bg-primary shadow-succession-md rounded-lg p-6 border border-succession-border transition-colors duration-300">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg font-medium text-succession-text-primary transition-colors duration-300">
          Business Continuity
        </h3>
        <svg 
          className="h-6 w-6 text-succession-text-secondary transition-colors duration-300" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
        </svg>
      </div>
      
      <div className="flex items-center mb-4">
        <svg 
          className="h-6 w-6 mr-3 text-succession-text-muted transition-colors duration-300" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
        </svg>
        <span className="text-base font-medium text-succession-text-secondary transition-colors duration-300">
          Create your Business Continuity Plan
        </span>
      </div>
      
      <div className="mt-4 mb-5">
        <div className="relative pt-1">
          <div className="flex mb-2 items-center justify-between">
            <div>
              <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-succession-warning bg-succession-warning-10 transition-colors duration-300">
                Create your Business Continuity Plan
              </span>
            </div>
            <div className="text-right">
              <span className="text-xs font-semibold inline-block text-succession-warning transition-colors duration-300">
                {completionPercentage}{pctSymbol()}
              </span>
            </div>
          </div>
          <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-succession-warning-10 transition-colors duration-300">
            <div
              style={{ width: `${completionPercentage}%` }}
              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-succession-warning transition-colors duration-300"
            ></div>
          </div>
        </div>
      </div>
      
      <div className="mt-6">
        <a
          href="/succession/bcp"
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-succession-primary hover:opacity-90 transition-all duration-300"
        >
          Start BCP
          <ArrowRightIcon className="ml-2 h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default BcpTileFallback; 